__turbopack_context__.v({
  "axisTitle": "changing-seasons-module__1U-Wxa__axisTitle",
  "bigStat": "changing-seasons-module__1U-Wxa__bigStat",
  "caveat": "changing-seasons-module__1U-Wxa__caveat",
  "chartCaption": "changing-seasons-module__1U-Wxa__chartCaption",
  "controls": "changing-seasons-module__1U-Wxa__controls",
  "durationAxis": "changing-seasons-module__1U-Wxa__durationAxis",
  "durationBars": "changing-seasons-module__1U-Wxa__durationBars",
  "durationHeading": "changing-seasons-module__1U-Wxa__durationHeading",
  "durationLabel": "changing-seasons-module__1U-Wxa__durationLabel",
  "durationLayout": "changing-seasons-module__1U-Wxa__durationLayout",
  "durationNumber": "changing-seasons-module__1U-Wxa__durationNumber",
  "durationReadout": "changing-seasons-module__1U-Wxa__durationReadout",
  "durationRow": "changing-seasons-module__1U-Wxa__durationRow",
  "durationTrack": "changing-seasons-module__1U-Wxa__durationTrack",
  "elevationFigure": "changing-seasons-module__1U-Wxa__elevationFigure",
  "elevationLayout": "changing-seasons-module__1U-Wxa__elevationLayout",
  "elevationPlot": "changing-seasons-module__1U-Wxa__elevationPlot",
  "elevationReadout": "changing-seasons-module__1U-Wxa__elevationReadout",
  "evidenceTag": "changing-seasons-module__1U-Wxa__evidenceTag",
  "gridLine": "changing-seasons-module__1U-Wxa__gridLine",
  "heading": "changing-seasons-module__1U-Wxa__heading",
  "interactionHint": "changing-seasons-module__1U-Wxa__interactionHint",
  "kicker": "changing-seasons-module__1U-Wxa__kicker",
  "meltRail": "changing-seasons-module__1U-Wxa__meltRail",
  "plotGrid": "changing-seasons-module__1U-Wxa__plotGrid",
  "pointLabel": "changing-seasons-module__1U-Wxa__pointLabel",
  "source": "changing-seasons-module__1U-Wxa__source",
  "sources": "changing-seasons-module__1U-Wxa__sources",
  "terrainKey": "changing-seasons-module__1U-Wxa__terrainKey",
  "terrainLine": "changing-seasons-module__1U-Wxa__terrainLine",
  "terrainTakeaway": "changing-seasons-module__1U-Wxa__terrainTakeaway",
  "thresholdList": "changing-seasons-module__1U-Wxa__thresholdList",
  "timingBars": "changing-seasons-module__1U-Wxa__timingBars",
  "timingGrid": "changing-seasons-module__1U-Wxa__timingGrid",
  "timingRail": "changing-seasons-module__1U-Wxa__timingRail",
  "timingRow": "changing-seasons-module__1U-Wxa__timingRow",
  "xAxis": "changing-seasons-module__1U-Wxa__xAxis",
  "yAxis": "changing-seasons-module__1U-Wxa__yAxis",
});
